import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toastUndo } from '../shell/toastStore';
import { useRunCommand } from './useRunCommand';
import { useStore } from './useServices';
import { useUndoVersionReader } from './useUndoVersion';

/**
 * Shows a toast with an "Undo" button for the command that just completed. The button reverses
 * exactly that command and disappears once the undo history moves on or after 10 seconds.
 */
export function useUndoToast(): (message: string) => void {
  const { t } = useTranslation();
  const store = useStore();
  const run = useRunCommand();
  const readVersion = useUndoVersionReader();
  return useCallback(
    (message: string) => {
      toastUndo(message, t('toast.undo'), readVersion(), () => {
        void run(() => store.undo());
      });
    },
    [t, store, run, readVersion],
  );
}
